import React, { useEffect, useState } from "react";
import SearchInput from "../../Components/Atoms/SearchInput";
import DropdownMenu from "../../Components/Atoms/DropdownMenu";
import {
  DateRange,
  Delete,
  Edit,
  KeyboardArrowDown,
  MoreVert,
  Print,
} from "@mui/icons-material";
import {
  Button,
  Checkbox,
  CircularProgress,
  Drawer,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import LogoutIcon from "@mui/icons-material/Logout";
import * as Yup from "yup";
import {
  getSampleListRequest,
  putSampleRequest,
  putSampleResponseClear,
} from "../../Redux/Sample/SampleActions";
import { useDispatch, useSelector } from "react-redux";
import NoRecords from "../../Components/Atoms/NoRecord";
import { useFormik } from "formik";
import TablePagination from "../../Components/Molecules/Pagination";
import CustomButton from "../../Components/Atoms/CustomButton";
import { handleDownloadFile } from "../../Components/Molecules/ExportData";
import toast from "react-hot-toast";
import TableHeader from "../../Components/Atoms/TableHeader";
import { DEFAULTS, MODULES, ROLE, ROLE_BY_PERMISSIONS } from "../../Constant";
import {
  getPurposeOfTestingDisplayName,
  hasPermission,
  isSuperAdmin,
} from "../../Utils/getters";
import { useNavigate } from "react-router-dom";
import {
  deleteVisitorLogRequest,
  deleteVisitorLogResponseClear,
  getVisitorLogsRequest,
  postExcelUploadRecordsVisitorLogResponseClear,
  postExcelUploadVisitorLogResponseClear,
  postVisitorLogResponseClear,
  putCheckoutVisitorLogRequest,
  putStatusChangeRequest,
} from "../../Redux/VisitorLogs/VisitorLogsActions";
import AvailableStatus from "../../Components/Atoms/AvailableStatus";
import CustomDialog from "../../Components/Molecules/CustomDialog";
import ConfirmModal from "../../Components/Molecules/ConfirmModal/Index";
import ImportExcel from "./Import/ImportExcelForm";
import ImportExcelErrors from "./Import/ImportExcelErrors";
import ImportExcelRecords from "./Import/ImportExcelRecords";
import VisitorLogsdFilter from "./Filters/VisitorLogsdFilter";
import moment from "moment-timezone";
import ViewVisitor from "./Forms/ViewVisitorForm";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import ReminderModal from "../../Components/Organisms/Layout/ReminderModal";

const IndexVisitorLogs = () => {
  const {
    getVisitorLogsLoading,
    getVisitorLogsResponse,
    postVistorLogResponse,
    postVisitorLogLoading,
    postExcelVisitorLogLoading,
    postExcelVisitorLogResponse,
    postExcelDataVisitorLogLoading,
    postExcelDataVisitorLogResponse,
    deleteVisitorLogLoading,
    deleteVisitorLogResponse,
  } = useSelector((state) => state.visitorLogReducer);
  const { getUserResponse } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);

  const searchSample = {
    filters: {
      search: {
        value: "",
      },
      status: {
        value: [],
        type: "array",
      },
      "other_details.type": {
        value: [],
        type: "array",
        is_mongoid: true,
      },
      "other_details.purpose_of_visit": {
        value: [],
        type: "array",
        is_mongoid: true,
      },
      "basic_details.check_in": {
        value: [],
        type: "date_range",
      },
      created_by: {
        value: [],
        type: "array",
        is_mongoid: true,
      },
    },
    limit: 10,
    page,
    sort: "",
  };

  const searchFormik = useFormik({
    initialValues: searchSample,
    onSubmit: () => {
      setPage(1);
      setReset(true);
      handleFilterClose();
      return dispatch(getVisitorLogsRequest(payload));
    },
    validationSchema: Yup.object().shape({
      filters: Yup.object().shape({
        "basic_details.check_in": Yup.object().shape({
          value: Yup.array()
            .of(Yup.date().nullable())
            .test(
              "end-date-required-if-start-given",
              "End date is required if start date is provided",
              function (value) {
                if (Array.isArray(value)) {
                  const [start, end] = value;
                  if (start && !end) {
                    return this.createError({
                      path: `${this.path}[1]`,
                      message: "End Date is Required",
                    });
                  } else if (!start && end) {
                    return this.createError({
                      path: `${this.path}[0]`,
                      message: "Start Date is Required",
                    });
                  } else if (start && end && new Date(start) > new Date(end)) {
                    return this.createError({
                      path: `${this.path}[0]`,
                      message: "Start date cannot be after end date",
                    });
                  }
                }
                return true;
              },
            ),
        }),
      }),
    }),
  });

  const payload = {
    filters: {
      search: {
        value: searchFormik.values.filters.search?.value,
      },
      status: {
        value:
          searchFormik.values.filters.status?.value?.map((el) => el?.value) ||
          [],
        type: "array",
      },
      "basic_details.check_in": {
        value:
          searchFormik.values.filters?.["basic_details.check_in"]?.value[0] &&
          searchFormik.values.filters?.["basic_details.check_in"]?.value[1]
            ? [
                searchFormik.values.filters?.["basic_details.check_in"]
                  ?.value[0],
                searchFormik.values.filters?.["basic_details.check_in"]
                  ?.value[1],
              ]
            : [],
        type: "date_range",
      },
      "other_details.type": {
        value:
          searchFormik.values.filters?.["other_details.type"]?.value?.map(
            (el) => el?._id,
          ) || [],
        type: "array",
      },
      "other_details.purpose_of_visit": {
        value:
          searchFormik.values.filters?.[
            "other_details.purpose_of_visit"
          ]?.value?.map((el) => el?._id) || [],
        type: "array",
      },
      created_by: {
        value:
          searchFormik.values.filters?.created_by?.value?.map(
            (el) => el?._id,
          ) || [],
        type: "array",
        is_mongoid: true,
      },
    },
    limit: 10,
    page: 1,
    sort: "",
  };

  useEffect(() => {
    if (
      postVisitorLogLoading ||
      deleteVisitorLogLoading ||
      postExcelDataVisitorLogLoading
    )
      return;
    dispatch(getVisitorLogsRequest({ ...payload, page }));
  }, [
    postVisitorLogLoading,
    deleteVisitorLogLoading,
    postExcelDataVisitorLogLoading,
  ]);

  useEffect(() => {
    if (postVistorLogResponse?.success) {
      toast.success(postVistorLogResponse?.message);
    } else if (postVistorLogResponse?.response?.data) {
      toast.error(postVistorLogResponse?.response?.data?.message);
    }
    setSelectedIds([]);
    return () => {
      dispatch(postVisitorLogResponseClear());
    };
  }, [postVistorLogResponse]);

  const [filter, setFilter] = useState(false);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (reset) return;
    dispatch(getVisitorLogsRequest(payload));
  }, [reset]);

  const headers = [
    "visitor_id",
    "basic_details.name",
    "other_details.type",
    // "id_type",
    // "nric_masking",
    // "fin_masking",
    // "passport",
    "basic_details.contact_no",
    "basic_details.email",
    "basic_details.address_details",
    "basic_details.description",
    "status",
    "basic_details.check_in",
    "basic_details.check_out",
    "other_details.from",
    "other_details.destination",
    "other_details.level",
    "other_details.block",
    "other_details.floor",
    "other_details.unit_no",
    "other_details.client",
    "other_details.vehicle_no",
    "other_details.pass_type",
    "other_details.pass_no",
    "other_details.remarks",
    "other_details.purpose_of_visit",
    "host_details.host_department",
    "host_details.host_name",
    "host_details.host_contact_no",
    "created_by",
    "status_by",
  ];

  // const values = {
  //   filters: searchFormik.values.filters,
  // };

  const handleExportButtonClick = (type) => {
    const date = moment(new Date()).tz(time_zone).format("DD-MM-YYYY");
    const mod_payload = { filters: payload.filters, page: "", limit: "" };
    if (type === "EXCEL") {
      handleDownloadFile({
        url: "visitor_logs/export/excel",
        filename: `visitor-logs-${date}.xlsx`,
        payload: { headers, ...mod_payload },
        method: "POST",
      });
    } else {
      handleDownloadFile({
        url: "visitor_logs/export/pdf",
        filename: `visitor-logs-${date}.pdf`,
        payload: { headers, ...mod_payload },
        method: "POST",
      });
    }
  };

  const handleFilter = () => {
    searchFormik.resetForm();
    setReset(false);
  };

  const openFilter = () => {
    setFilter(true);
  };
  const handleFilterClose = () => {
    const is_formik_errors = Object.keys(searchFormik.errors).length > 0;
    if (is_formik_errors) return;
    setFilter(false);
  };
  const navigate = useNavigate();

  const getStatusOptions = (data) => {
    const { visitor_id, status, _id } = data;
    const sub_text =
      "This will move this record permanently, You cannot undo this action";
    switch (status) {
      case "CHECKIN":
        return [
          {
            label: "Check-Out",
            onClick: () => {
              handleStatusOpen();
              setStatusConfig({
                _id,
                visitor_id,
                sub_text,
                status: "CHECKOUT",
                main_text:
                  "Are you sure you want to change status to CHECKOUT ?",
              });
            },
            icon: <LogoutIcon />,
            tooltip: "Checkout Process",
          },
          {
            label: "Cancel",
            onClick: () => {
              handleStatusOpen();
              setStatusConfig({
                _id,
                visitor_id,
                status: "CANCELLED",
                sub_text,
                main_text: "Are you sure you want to change status to CANCEL ?",
              });
            },
            icon: <CloseIcon />,
            tooltip: "Cancel Process",
          },
        ];
      // case "CHECKOUT":
      //   return [
      //     {
      //       label: "Mark As Blacklist",
      //       onClick: () => {
      //         handleStatusOpen();
      //         setStatusConfig({
      //           _id,
      //           status: "BLACKLIST",
      //           visitor_id,
      //           sub_text,
      //           main_text:
      //             "Are you sure you want to change status to BLACKLIST ?",
      //         });
      //       },
      //       icon: <BlockIcon />,
      //       tooltip: "Blacklist Process",
      //     },
      //   ];
      default:
        break;
    }
  };

  const [statusConfig, setStatusConfig] = useState({
    main_text: "",
    sub_text: "",
    visitor_id: "",
  });
  const [statusOpen, setStatusOpen] = useState(false);
  const handleStatusOpen = () => setStatusOpen(true);
  const handleStatusClose = () => {
    setStatusOpen(false);
  };

  //

  const [importOpen, setImportOpen] = useState(false);
  const handleImportOpen = () => setImportOpen(true);
  const handleImportClose = () => {
    setImportOpen(false);
  };

  const [importErrorOpen, setImportErrorOpen] = useState(false);
  const handleImportErrorOpen = () => setImportErrorOpen(true);
  const handleImportErrorClose = () => {
    setImportErrorOpen(false);
    dispatch(postExcelUploadVisitorLogResponseClear());
  };

  const [importSuccessOpen, setImportSuccessOpen] = useState(false);
  const handleImportSuccessOpen = () => setImportSuccessOpen(true);
  const handleImportSuccessClose = () => {
    setImportSuccessOpen(false);
    dispatch(postExcelUploadVisitorLogResponseClear());
  };

  useEffect(() => {
    if (postExcelVisitorLogLoading) return;
    handleImportClose();
    if (postExcelVisitorLogResponse?.success) {
      handleImportSuccessOpen();
    } else if (postExcelVisitorLogResponse?.success === false) {
      handleImportErrorOpen();
    }
  }, [postExcelVisitorLogLoading]);

  const [deleteConfig, setDeleteConfig] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDeleteOpen = () => setDeleteOpen(true);
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  useEffect(() => {
    if (
      deleteVisitorLogResponse?.success &&
      deleteVisitorLogResponse?.message
    ) {
      toast.success(deleteVisitorLogResponse?.message);
    } else if (deleteVisitorLogResponse?.response?.data) {
      toast.error(deleteVisitorLogResponse?.response?.data?.message);
    }
    return () => {
      dispatch(deleteVisitorLogResponseClear());
    };
  }, [deleteVisitorLogResponse]);

  useEffect(() => {
    if (
      postExcelDataVisitorLogResponse?.success &&
      postExcelDataVisitorLogResponse?.message
    ) {
      toast.success(postExcelDataVisitorLogResponse?.message);
      handleImportSuccessClose();
    } else if (postExcelDataVisitorLogResponse?.response?.data) {
      toast.error(postExcelDataVisitorLogResponse?.response?.data?.message);
    }
    return () => {
      dispatch(postExcelUploadRecordsVisitorLogResponseClear());
    };
  }, [postExcelDataVisitorLogResponse]);

  const time_zone =
    getUserResponse?.data?.settings?.time_zone || DEFAULTS.TIME_ZONE;

  const date_time_format =
    getUserResponse?.data?.settings?.date_time_format ||
    DEFAULTS.DATE_TIME_FORMAT;

  const [viewOpen, setViewOpen] = useState(false);
  const [viewData, setViewData] = useState(null);
  const handleOpenView = (data) => {
    setViewOpen(true);
    setViewData(data);
  };
  const handleCloseView = () => {
    setViewOpen(false);
    setViewData(null);
  };
  //

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [moreActions, setMoreActions] = useState([]);

  const handleClick = (event, each) => {
    const { _id: row_id } = each;
    setAnchorEl(event.currentTarget);
    setCurrentRowId(row_id);
    const res = getStatusOptions(each);
    setMoreActions(res);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentRowId(null);
  };

  //

  const [openCheckout, setOpenCheckout] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const handleOpenCheckout = (data) => {
    setSelectedIds([]);
    setOpenCheckout(true);
    setSelectedVisitor(data);
  };
  const handleCloseheckout = () => {
    setOpenCheckout(false);
    setSelectedVisitor(null);
  };

  //

  const [selectedIds, setSelectedIds] = useState([]);

  const handleSelectOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((itemId) => itemId !== id)
        : [...prev, id],
    );
  };

  const [openBatchCheckout, setOpenBatchCheckout] = useState(false);
  const handleOpenBatchCheckout = () => {
    setOpenBatchCheckout(true);
  };
  const handleCloseBatchCheckout = () => {
    setOpenBatchCheckout(false);
  };

  const [printOpen, setPrintOpen] = useState(false);
  const [printData, setPrintData] = useState([]);
  const handlePrintOpen = (data) => {
    setPrintOpen(true);
    setPrintData([data]);
  };
  const handlePrintClose = () => {
    setPrintOpen(false);
    setPrintData([]);
  };

  return (
    <>
      <CustomDialog
        maxWidth="sm"
        title={`BATCH CHECKOUT - NO OF SELECTED VISITORS : ${selectedIds.length}`}
        handleClose={handleCloseBatchCheckout}
        open={openBatchCheckout}
      >
        <ConfirmModal
          button_label={"SUBMIT"}
          icon_type={"DONE"}
          message={"Are you sure you want to batch check-out?"}
          subMessage={
            "This will process batch check-out. You cannot undo This Action."
          }
          loading={deleteVisitorLogLoading}
          handleSubmit={() => {
            dispatch(
              putCheckoutVisitorLogRequest({
                visitor_ref: selectedIds,
                checkout_method: "BATCH",
              }),
            );
            handleCloseBatchCheckout();
          }}
          handleClose={handleCloseBatchCheckout}
        />
      </CustomDialog>

      <CustomDialog
        maxWidth="sm"
        title={`VISITOR ID - ${selectedVisitor?.visitor_id}`}
        handleClose={handleCloseheckout}
        open={openCheckout}
      >
        <ConfirmModal
          button_label={"SUBMIT"}
          icon_type={"DONE"}
          message={"Are you sure you want to check-out this record ?"}
          subMessage={
            "This will check-out this record permanently, You cannot undo This Action."
          }
          loading={deleteVisitorLogLoading}
          handleSubmit={() => {
            dispatch(
              putCheckoutVisitorLogRequest({
                visitor_ref: [selectedVisitor?._id],
                checkout_method: "NORMAL",
              }),
            );
            handleCloseheckout();
          }}
          handleClose={handleCloseheckout}
        />
      </CustomDialog>

      {/* <CustomDialog
        maxWidth="xl"
        title={`VISITOR DETAILS  - ${viewData?.visitor_id}`}
        handleClose={handleCloseView}
        open={viewOpen}
      >
        <ViewVisitor data={viewData} handleClose={handleCloseView} />
      </CustomDialog> */}

      <CustomDialog
        maxWidth="md"
        title={"VISITOR / CONTRACTOR PASS"}
        handleClose={handlePrintClose}
        open={printOpen}
      >
        <ReminderModal
          data={printData}
          handleClose={handlePrintClose}
          mode={"PRINT"}
        />
      </CustomDialog>

      <Drawer
        anchor="right"
        open={filter}
        onClose={(e, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleFilterClose();
          }
        }}
      >
        <VisitorLogsdFilter
          searchFormik={searchFormik}
          handleFilterClose={handleFilterClose}
          handleFilter={handleFilter}
        />
      </Drawer>

      <CustomDialog
        maxWidth="sm"
        title={`VISITOR ID - ${deleteConfig?.visitor_id}`}
        handleClose={handleDeleteClose}
        open={deleteOpen}
      >
        <ConfirmModal
          message={"Are you sure you want to delete this record ?"}
          subMessage={
            "This will delete this record permanently, You cannot undo This Action."
          }
          loading={deleteVisitorLogLoading}
          handleSubmit={() => {
            dispatch(deleteVisitorLogRequest({ _id: deleteConfig?._id }));
            handleDeleteClose();
          }}
          handleClose={handleDeleteClose}
        />
      </CustomDialog>

      <CustomDialog
        maxWidth="md"
        title={"IMPORT - VISITOR LOGS"}
        handleClose={handleImportClose}
        open={importOpen}
      >
        <ImportExcel handleClose={handleImportClose} />
      </CustomDialog>

      <CustomDialog
        maxWidth="md"
        title={"IMPORT - ERROR LIST"}
        handleClose={handleImportErrorClose}
        open={importErrorOpen}
      >
        <ImportExcelErrors handleClose={handleImportErrorClose} />
      </CustomDialog>

      <CustomDialog
        maxWidth="xl"
        title={"IMPORT - CONFIRM VISITOR LOGS"}
        handleClose={handleImportSuccessClose}
        open={importSuccessOpen}
      >
        <ImportExcelRecords handleClose={handleImportSuccessClose} />
      </CustomDialog>

      <CustomDialog
        maxWidth="sm"
        title={`ID - ${statusConfig?.visitor_id}`}
        handleClose={handleStatusClose}
        open={statusOpen}
      >
        <ConfirmModal
          message={statusConfig?.main_text}
          button_label="SUBMIT"
          icon_type="DONE"
          subMessage={statusConfig?.sub_text}
          handleSubmit={() => {
            dispatch(
              putStatusChangeRequest({
                _id: statusConfig?._id,
                status: statusConfig?.status,
              }),
            );
            handleStatusClose();
          }}
          handleClose={handleStatusClose}
        />
      </CustomDialog>

      <div className="cntr">
        <div className="hdrComp">
          <h6>VISITOR LOGS</h6>
          <div className="rtActnWrpr">
            <SearchInput
              value={searchFormik.values.filters.search.value}
              name={"filters.search.value"}
              onChange={searchFormik.handleChange}
              handleSubmit={searchFormik.handleSubmit}
              searchFormik={searchFormik}
              searchSample={searchSample}
            />

            {hasPermission(
              [ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS].CREATE_VISITOR_LOGS],
              getUserResponse?.data,
            ) && (
              <CustomButton
                onClick={() => navigate("/visitor-logs/new")}
                label={"NEW"}
                action={"NEW"}
                size="small"
              />
            )}
            {hasPermission(
              [ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS].IMPORT_VISITOR_LOGS],
              getUserResponse?.data,
            ) && (
              <CustomButton
                onClick={handleImportOpen}
                action={"IMPORT"}
                label={"IMPORT"}
                size="small"
              />
            )}

            {hasPermission(
              [ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS].EXPORT_VISITOR_LOGS],
              getUserResponse?.data,
            ) && (
              <CustomButton
                onClick={() => handleExportButtonClick("EXCEL")}
                action={"EXCEL"}
                label={"EXCEL"}
                size="small"
              />
            )}

            {hasPermission(
              [ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS].EXPORT_VISITOR_LOGS],
              getUserResponse?.data,
            ) && (
              <CustomButton
                onClick={() => handleExportButtonClick("PDF")}
                action={"PDF"}
                label={"PDF"}
                size="small"
              />
            )}

            <CustomButton
              action={"FILTER"}
              onClick={openFilter}
              label={"FILTER"}
              size="small"
            />

            {selectedIds.length > 0 && (
              <CustomButton
                action={"LOGOUT"}
                onClick={handleOpenBatchCheckout}
                label={"CHECKOUT"}
                size="small"
              />
            )}
          </div>
        </div>
        {getVisitorLogsLoading && !getVisitorLogsResponse?.data?.length > 0 ? (
          <div className="d-flex align-items-center justify-content-center">
            <CircularProgress size={25} />
          </div>
        ) : (
          <TablePagination
            showFilter={true}
            showSort={true}
            setPage={setPage}
            page={page}
            initialValues={searchSample}
            formik={searchFormik}
            action={(values) => dispatch(getVisitorLogsRequest(values))}
            result={getVisitorLogsResponse}
            count={getVisitorLogsResponse?.data?.total_count}
          >
            <div className="tblWrpr">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {hasPermission(
                        [
                          ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                            .CHECKOUT_VISITOR_LOGS,
                        ],
                        getUserResponse?.data,
                      ) ? (
                        <th>SELECT</th>
                      ) : (
                        <th>-</th>
                      )}
                      <th>SI.NO</th>
                      <th>VISITOR ID</th>
                      <th>NAME</th>
                      {/* <th>ID TYPE</th>
                      <th>ID</th> */}
                      <th>CHECK-IN</th>
                      <th>CHECK-OUT</th>
                      <th>FROM</th>
                      <th>CLIENT</th>
                      <th>DESTINATION</th>
                      <th>TYPE</th>
                      <th>VEHICLE NO</th>
                      <th>PURPOSE</th>
                      <th>STATUS</th>
                      {isSuperAdmin(getUserResponse?.data) && (
                        <th>CREATED BY</th>
                      )}
                      <th>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getVisitorLogsResponse?.data?.length > 0 ? (
                      getVisitorLogsResponse?.data?.map((data, index) => {
                        return (
                          <tr key={data._id}>
                            {hasPermission(
                              [
                                ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                                  .CHECKOUT_VISITOR_LOGS,
                              ],
                              getUserResponse?.data,
                            ) && data?.status === "CHECKIN" ? (
                              <td>
                                <Checkbox
                                  checked={selectedIds.includes(data._id)}
                                  onChange={() => handleSelectOne(data._id)}
                                />
                              </td>
                            ) : (
                              <td>-</td>
                            )}
                            <td>
                              {searchFormik?.values?.limit * (page - 1) +
                                index +
                                1}
                            </td>
                            <td>{data?.visitor_id}</td>
                            <td>{data?.basic_details?.name}</td>
                            {/* <td>{data?.id_type}</td>
                            <td>
                              {data?.id_type === "NRIC"
                                ? data?.nric_masking
                                : data?.id_type === "FIN"
                                  ? data?.fin_masking
                                  : data?.passport}
                            </td> */}
                            <td>
                              {data?.basic_details?.check_in
                                ? moment(data?.basic_details?.check_in)
                                    .tz(time_zone)
                                    .format(date_time_format)
                                : "-"}
                            </td>
                            <td>
                              {data?.basic_details?.check_out ? (
                                moment(data?.basic_details?.check_out)
                                  .tz(time_zone)
                                  .format(date_time_format)
                              ) : hasPermission(
                                  [
                                    ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                                      .CHECKOUT_VISITOR_LOGS,
                                  ],
                                  getUserResponse?.data,
                                ) && data.status === "CHECKIN" ? (
                                <Button
                                  variant="outlined"
                                  onClick={() => handleOpenCheckout(data)}
                                  size={"small"}
                                  color="error"
                                  endIcon={<DateRange />}
                                >
                                  Check-Out
                                </Button>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{data?.other_details?.from || "-"}</td>
                            <td>{data?.other_details?.client?.name || "-"}</td>
                            <td>
                              {data?.other_details?.destination?.name || "-"}
                            </td>
                            <td>{data?.other_details?.type?.name || "-"}</td>
                            <td>{data?.other_details?.vehicle_no || "-"}</td>
                            <td>
                              {data?.other_details?.purpose_of_visit?.name ||
                                "-"}
                            </td>
                            <td>
                              <AvailableStatus
                                status={data?.status}
                                customCls={
                                  data?.status === "CHECKIN"
                                    ? "index-green"
                                    : "index-red"
                                }
                              />
                            </td>
                            {isSuperAdmin(getUserResponse?.data) && (
                              <td>{data?.created_by?.first_name || "-"}</td>
                            )}
                            <td>
                              <div className="d-flex gap-3">
                                <div className="view">
                                  <button
                                    onClick={() => {
                                      navigate(
                                        `/visitor-logs/view/${data?._id}`,
                                      );
                                      // handleOpenView(data);
                                    }}
                                  >
                                    <VisibilityIcon />
                                  </button>
                                  {hasPermission(
                                    [
                                      ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                                        .UPDATE_VISITOR_LOGS,
                                    ],
                                    getUserResponse?.data,
                                  ) &&
                                    data?.status === "CHECKIN" && (
                                      <button
                                        onClick={() =>
                                          navigate(
                                            `/visitor-logs/edit?id=${data?._id}`,
                                          )
                                        }
                                      >
                                        <Edit />
                                      </button>
                                    )}
                                  {hasPermission(
                                    [
                                      ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                                        .DELETE_VISITOR_LOGS,
                                    ],
                                    getUserResponse?.data,
                                  ) && (
                                    <button
                                      onClick={() => {
                                        setDeleteConfig({
                                          ...data,
                                        });
                                        handleDeleteOpen();
                                      }}
                                    >
                                      <Delete />
                                    </button>
                                  )}
                                  {hasPermission(
                                    [
                                      ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                                        .PRINT_VISITOR_LOGS,
                                    ],
                                    getUserResponse?.data,
                                  ) && (
                                    <button
                                      onClick={() => {
                                        handlePrintOpen({
                                          visitor_log_ref: data,
                                        });
                                      }}
                                    >
                                      <Print />
                                    </button>
                                  )}
                                  {/* {hasPermission(
                                    [
                                      ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                                        .STATUS_VISITOR_LOGS,
                                    ],
                                    getUserResponse?.data
                                  ) &&
                                    ["CHECKIN"].includes(
                                      // ["CHECKIN", "CHECKOUT"].includes(
                                      data?.status
                                    ) && (
                                      <button
                                        onClick={(event) =>
                                          handleClick(event, data)
                                        }
                                      >
                                        <MoreVertIcon />
                                      </button>
                                    )}
                                  <Menu
                                    anchorEl={anchorEl}
                                    open={currentRowId === data?._id}
                                    onClose={handleClose}
                                  >
                                    {moreActions.map((e) => {
                                      const { label, onClick, tooltip, icon } =
                                        e;
                                      return (
                                        <Tooltip
                                          title={tooltip}
                                          placement="right"
                                        >
                                          <MenuItem
                                            onClick={() => {
                                              onClick();
                                              handleClose();
                                            }}
                                          >
                                            <ListItemIcon>{icon}</ListItemIcon>
                                            {label}
                                          </MenuItem>
                                        </Tooltip>
                                      );
                                    })}
                                  </Menu> */}
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <NoRecords />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </TablePagination>
        )}
      </div>
    </>
  );
};

export default IndexVisitorLogs;
